@let loading = (loading$ | async) || false;
@let stripeStep = (stripeStep$ | async) || false;
@let stripeFinal = (stripeFinal$ | async) || false;
@let canFinalizePayment = (canFinalizePayment$ | async) || false;

<div kendoTooltip class="example-wrapper" #rootElement>
  <div class="notification-container" #notificationContainer></div>
  <kendo-dialog *ngIf="dialogOpened$ | async" (close)="cancel()" width="100%">
    <kendo-dialog-titlebar>
      <div class="container-fluid">
        <div class="row">
          <img
            class="align-self-center logo"
            src="data:image/png;base64, {{ session?.merchant?.logo }}"
            alt="{{ session?.merchant?.name }}"
          />
        </div>
      </div>
    </kendo-dialog-titlebar>
    <div class="container-fluid subtitle">
      <div class="row">
        <div class="column d-none d-lg-block">
          <h2 class="subtitle-text">Add a payment method</h2>

          <!--          <div style="position: absolute; right: 32px; top: 16px">-->
          <!--            <button-->
          <!--              class="k-button-clear e2e-clear"-->
          <!--              [class.selected]="currentLanguage === 'en'"-->
          <!--              (click)="setLanguage('en')"-->
          <!--              [disabled]="loading"-->
          <!--            >-->
          <!--              EN-->
          <!--            </button>-->
          <!--            <button-->
          <!--              class="k-button-clear e2e-clear"-->
          <!--              [class.selected]="currentLanguage === 'fr'"-->
          <!--              (click)="setLanguage('fr')"-->
          <!--              [disabled]="loading"-->
          <!--            >-->
          <!--              FR-->
          <!--            </button>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div class="container-lg main">
      <div class="row main-row">
        <div class="col-12 col-lg-8">
          <div class="row section">
            <div class="col-12 d-flex">
              <div class="align-self-center">
                <kendo-svg-icon
                  [icon]="icons.userIcon"
                  size="xlarge"
                  themeColor="primary"
                ></kendo-svg-icon>
              </div>

              <div class="section-header-container">
                <h3 class="section-header">1. Client details</h3>
              </div>
              <div class="flex-grow-1"></div>
              <div class="edit-button-container" *ngIf="stripeStep">
                <button
                  kendoButton
                  themeColor="secondary"
                  fillMode="link"
                  (click)="showClient($event)"
                  [disabled]="loading"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="dark"
                    class="edit-loader"
                  />
                  Edit
                </button>
              </div>
            </div>
            <form
              [formGroup]="form"
              (ngSubmit)="createCustomerSession()"
              [ngClass]="{ collapsed: stripeStep }"
              class="col-12"
            >
              <div class="row client-details-container">
                <div class="col-md-6" *ngIf="policyId?.show">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="policyId"
                    fieldName="policyId"
                    formControlName="policyId"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="shouldDisplayClientInfo('customerId')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('customerId')"
                    fieldName="customerId"
                    formControlName="customerId"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="shouldDisplayClientInfo('firstName')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('firstName')"
                    fieldName="firstName"
                    formControlName="firstName"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="shouldDisplayClientInfo('lastName')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('lastName')"
                    fieldName="lastName"
                    formControlName="lastName"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="shouldDisplayClientInfo('insuredName')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('insuredName')"
                    fieldName="insuredName"
                    formControlName="insuredName"
                  ></app-input-field>
                </div>
                <div class="col-md-6" *ngIf="shouldDisplayClientInfo('email')">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('email')"
                    fieldName="email"
                    formControlName="email"
                  ></app-input-field>
                </div>
                <div class="col-12" *ngIf="shouldDisplayClientInfo('address')">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('address')"
                    fieldName="address"
                    formControlName="address"
                  ></app-input-field>
                </div>
                <div class="w-100 p-0 m-0"></div>
                <div class="col-md-4" *ngIf="shouldDisplayClientInfo('city')">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('city')"
                    fieldName="city"
                    formControlName="city"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-4"
                  *ngIf="shouldDisplayClientInfo('province')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('province')"
                    fieldName="province"
                    formControlName="province"
                  ></app-input-field>
                </div>
                <div class="col-md-4" *ngIf="shouldDisplayClientInfo('zip')">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('zip')"
                    fieldName="zip"
                    formControlName="zip"
                  ></app-input-field>
                </div>
              </div>
              <div class="row section-action client-details-container">
                <div class="col-lg-8 d-none d-lg-block"></div>
                <div class="col-lg-4 d-flex">
                  <button
                    kendoButton
                    size="large"
                    themeColor="primary"
                    class="flex-grow-1"
                    type="submit"
                    [disabled]="loading || this.form.invalid"
                  >
                    <kendo-loader
                      *ngIf="loading"
                      type="infinite-spinner"
                      size="small"
                      themeColor="light"
                    />
                    Save details
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="row section">
            <div class="col-12 d-flex">
              <div class="align-self-center">
                <kendo-svg-icon
                  [icon]="icons.walletIcon"
                  size="xlarge"
                  themeColor="primary"
                ></kendo-svg-icon>
              </div>

              <div class="section-header-container">
                <h3 class="section-header">2. Add a payment method</h3>
              </div>
              <div class="flex-grow-1"></div>
              <div class="edit-button-container" *ngIf="stripeFinal">
                <button
                  kendoButton
                  themeColor="secondary"
                  fillMode="link"
                  (click)="showPaymentMethod($event)"
                  [disabled]="loading"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="dark"
                    class="edit-loader"
                  />
                  Edit
                </button>
              </div>
            </div>
            <div class="col-12">
              <form
                (submit)="stripeSubmit($event)"
                [ngClass]="{ collapsed: !stripeStep || stripeFinal }"
              >
                <div class="row client-details-container">
                  <div class="col-12">
                    <slot name="stripe-container"></slot>
                  </div>
                </div>
                <div class="row section-action client-details-container">
                  <div class="col-lg-8 d-none d-lg-block"></div>
                  <div class="col-lg-4 d-flex">
                    <button
                      kendoButton
                      size="large"
                      themeColor="primary"
                      class="flex-grow-1"
                      type="submit"
                      [disabled]="loading"
                    >
                      <kendo-loader
                        *ngIf="loading"
                        type="infinite-spinner"
                        size="small"
                        themeColor="light"
                      />
                      Next
                    </button>
                  </div>
                </div>
              </form>
              <div
                [ngClass]="{ collapsed: !stripeFinal }"
                class="payment-method-container"
              >
                <hr />
                <p class="payment-method">
                  {{ brand }} Ending in {{ identifier }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 d-flex flex-column summary">
          <div class="row">
            <div class="col">
              <h3 class="summary-header">3. Agreement</h3>
            </div>
          </div>
          <form (submit)="submitAgreement($event)">
            <div class="row pay-section">
              <div class="col d-flex">
                <div class="k-form-field-checkbox-wrap d-flex">
                  <kendo-checkbox
                    (checkedStateChange)="agreementChecked($event)"
                    #agreement
                  ></kendo-checkbox>
                  <kendo-label
                    [for]="agreement"
                    class="k-checkbox-label"
                    [innerHTML]="translate(disclaimer)"
                  ></kendo-label>
                </div>
              </div>
            </div>
            <div class="row pay-section">
              <div class="col d-flex">
                <button
                  kendoButton
                  [disabled]="!canFinalizePayment || loading"
                  themeColor="primary"
                  size="large"
                  class="flex-grow-1"
                  type="submit"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="light"
                  />
                  Save payment method
                </button>
              </div>
            </div>
          </form>
          <div class="row flex-grow-1"></div>
          <div class="row logo-section">
            <div class="col justify-content-around d-flex">
              <img
                src="{{ logo }}"
                alt="insurepay payments logo"
                class="ip-logo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </kendo-dialog>
</div>
